import { createContext, useContext } from 'react';

/** "AI not in your plan" upsell dialog (medopd-docs 126) — provided once by AiUpsellProvider. */
export interface AiUpsellContextValue {
  /** Opens the dialog. `featureLabel` names what the user tried to use ("Record consultation"). */
  openUpsell: (featureLabel?: string) => void;
}

export const AiUpsellContext = createContext<AiUpsellContextValue | null>(null);

/** null outside AiUpsellProvider (e.g. isolated component tests). */
export function useAiUpsell(): AiUpsellContextValue | null {
  return useContext(AiUpsellContext);
}
